import React from 'react'
import PropTypes from 'prop-types'

const ErrorAlert = (props) => {
  const { title, body } = props
  return <div className="alert alert-danger" role="alert">
    <h4 className="alert-heading">{title}</h4>
    <p>{body}. Make sure you are connected to the VPN</p>
  </div>
}

ErrorAlert.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string
}

ErrorAlert.defaultProps = {
  title: '',
  body: ''
}

export default ErrorAlert


// WEBPACK FOOTER //
// ./src/components/alerts/error.js